import { render, staticRenderFns } from "./odco-dzcpxshtfb.vue?vue&type=template&id=62ad1d94&scoped=true&"
import script from "./odco-dzcpxshtfb.vue?vue&type=script&lang=js&"
export * from "./odco-dzcpxshtfb.vue?vue&type=script&lang=js&"
import style0 from "./odco-dzcpxshtfb.vue?vue&type=style&index=0&id=62ad1d94&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62ad1d94",
  null
  
)

export default component.exports